import { BaseFilter, LogicOperatorFilter } from './baseFilters.js';
import { FilterGeo, FilterGeoWithin } from './geoFilters.js';
import { FilterAllOf, FilterAnyOf } from './listFilters.js';
import { FilterEqual, FilterExists, FilterGreaterOrEqualThan, FilterGreaterThan, FilterLessOrEqualThan, FilterLessThan, } from './logicFilters.js';
class FilterOr extends LogicOperatorFilter {
    // eslint-disable-next-line no-use-before-define
    constructor(filter = []) {
        super('or', filter);
    }
}
/**
 * Composable filters: And, or and not
 */
class FilterAnd extends LogicOperatorFilter {
    // eslint-disable-next-line no-use-before-define
    constructor(filter = []) {
        super('and', filter);
    }
}
class FilterNot extends BaseFilter {
    // eslint-disable-next-line no-use-before-define
    constructor(filter) {
        super();
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // eslint-disable-next-line no-use-before-define
        Object.defineProperty(this, "filter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.type = 'not';
        this.filter = filter;
    }
    // eslint-disable-next-line no-use-before-define
    get() {
        return this.filter;
    }
    getType() {
        return this.type;
    }
    toJson() {
        return {
            type: this.type,
            filter: this.filter,
        };
    }
}
export { FilterAnd, FilterExists, FilterGreaterOrEqualThan, FilterGreaterThan, FilterLessOrEqualThan, FilterLessThan, FilterEqual, FilterNot, FilterOr, FilterGeo, FilterGeoWithin, FilterAllOf, FilterAnyOf, };
